
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const constantRouterMap = [  
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    component: resolve => require(['@/views/home/index.vue'], resolve),
  },
  { // 登录
    path: '/login',
    name: 'login',
    component: resolve => require(['@/views/login/login.vue'], resolve),
  }, 
  { // 注册
    path: '/signup',
    name: 'signup',
    component: resolve => require(['@/views/login/signup.vue'], resolve),
  },  
  { // 重置密码
    path: '/resetPassword',
    name: 'resetPassword',
    component: resolve => require(['@/views/login/resetPassword.vue'], resolve),
  },   
  {
    path: '/',
    component: resolve => require(['@/views/index.vue'], resolve),
    children: [
      { // 仪表板
        path: 'dashboard',
        name: 'dashboard',
        component: resolve => require(['@/views/dashboard/index.vue'], resolve),
      },
      { // 代理生成国家
        path: 'proxyCountry',
        name: 'proxyCountry',
        component: resolve => require(['@/views/proxyCountry/index.vue'], resolve),
      },
      { // 代理生成城市
        path: 'proxyCity',
        name: 'proxyCity',
        component: resolve => require(['@/views/proxyCity/index.vue'], resolve),
      },
      { // 购买流量
        path: 'purchaseTraffic',
        name: 'purchaseTraffic',
        component: resolve => require(['@/views/purchaseTraffic/index.vue'], resolve),
      },
      { // 购买代理
        path: 'purchaseAgent',
        name: 'purchaseAgent',
        component: resolve => require(['@/views/purchaseAgent/index.vue'], resolve),
      },
      { // 已购明细
        path: 'purchasedDetails',
        name: 'purchasedDetails',
        component: resolve => require(['@/views/purchasedDetails/index.vue'], resolve),
      },
      { // 历史订单
        path: 'historicalOrders',
        name: 'historicalOrders',
        component: resolve => require(['@/views/historicalOrders/index.vue'], resolve),
      },
      { // 服务条款
        path: 'customerPolicy',
        name: 'customerPolicy',
        component: resolve => require(['@/views/customerPolicy/index.vue'], resolve),
      },
      { // 帮助文档
        path: 'helpDocuments',
        name: 'helpDocuments',
        component: resolve => require(['@/views/helpDocuments/index.vue'], resolve),
      },
      { // 开发者API
        path: 'developerAPI',
        name: 'developerAPI',
        component: resolve => require(['@/views/developerAPI/index.vue'], resolve),
      },
      { // 奖励推广
        path: 'inviteReward',
        name: 'inviteReward',
        component: resolve => require(['@/views/inviteReward/index.vue'], resolve),
      },
    ]
  }, 
  {
    path: '*',
    component: resolve => require(['@/components/404.vue'], resolve)
  }
]

const router = new Router({
  mode:'history',
  // base: '/dist/',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

export default router